import type { Abi, Address } from "viem"
import type { Config } from "wagmi"
import { readContract } from "@wagmi/core"

import { routerAbi } from "@/domains/abis"

export type ScaleSwapRouterRoute = {
  from: Address
  to: Address
  stable: boolean
}

type GetScaleSwapAmountsOutParams = {
  chainId: number
  config: Config
  routerAddress: Address
  amountIn: bigint
  routes: ScaleSwapRouterRoute[]
}

export const getScaleSwapAmountsOut = async ({
  chainId,
  config,
  routerAddress,
  amountIn,
  routes,
}: GetScaleSwapAmountsOutParams): Promise<bigint[]> => {
  const amounts = await readContract(config, {
    address: routerAddress,
    abi: routerAbi as Abi,
    functionName: "getAmountsOut",
    args: [amountIn, routes],
    chainId,
  })

  return amounts as bigint[]
}
